import FileDropZone from './FileDropZone';

export default FileDropZone;
